<template>
	<router-link v-slot="{ href, navigate }" :to="homeRoute" custom>
		<a :href="href" class="header-logo" @click="onLogoClick(navigate, $event)">
			<app-tooltip
				class="header-logo__tooltip"
				:text="$t('server_version', { version: serverVersion })"
				:disabled="!serverVersion"
			>
				<template #activator>
					<app-icon name="logo" width="123px" height="24px" />
				</template>
			</app-tooltip>
		</a>
	</router-link>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue"
import type { RouteLocationRaw } from "vue-router"
import { chatsStore } from "@/store/chats"
import { rootStore } from "@/store/index"
import { VersionApi } from "@/ api/VersionApi"

const root = rootStore()

const serverVersion = ref('')

const homeRoute: RouteLocationRaw = {
	path: '/main',
	query: {
		page: 'chat',
		mode: 'list'
	}
}

const onLogoClick = (navigate: (e: MouseEvent) => void, e: MouseEvent) => {
	if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
		return
	}

	chatsStore().setMode('list')
	chatsStore().setOpenedChat(null)
	navigate(e)
}

const fetchServerVersion = async () => {
	const versions = await VersionApi.getVersions()
	const version = versions?.ServerVersion
	if (!version) {
		return
	}

	serverVersion.value = [version.Global, version.Component, version.Update, version.Fix].join('.')
}

onMounted(() => {
	if (root.globalJWT) {
		fetchServerVersion()
		return
	}
	const unwatch = watch(() => root.globalJWT, (token) => {
		if (token) {
			fetchServerVersion()
			unwatch()
		}
	})
})
</script>

<style scoped>
.header-logo {
	display: flex;
	align-items: center;
	cursor: pointer;
	color: inherit;
	text-decoration: none;
}

.header-logo__tooltip,
.header-logo__tooltip :deep(.app-tooltip__activator) {
	display: flex;
}
</style>
